const moment = require('moment');
/** 
 * @author Miguel González.
 * @description funcion que serializa el booking
 * created 26-09-2023 12:30  */
export const serializeBooking = ( booking ) => {
    const bookingSerialized = {
        id: {
            value: booking.id_booking,
            show: true,
        },
        itinerary_id: {
            value: booking.itinerary_id,
            show: true,
        },
        year: {
            value: {
                id: moment().format('YYYY'),
                name: moment().format('YYYY'),
            },
            show: true,
        },
        week: {
            value: {
                id: booking.semana ? booking.semana.toString() : moment().week().toString(),
                name: booking.semana ? booking.semana.toString() : moment().week().toString(),
            },
            show: true,
        },
        id_client: {
            value: {
                id: booking.id_cliente,
                name: booking.cliente,
            },
            show: true,
        },
        port_load_id: {
            value: {
                id: booking.id_pol,
                name: booking.pol,
            },
            show: true,
        },
        port_origin_id: {
            value: {
                id: booking.id_pol,
                name: booking.puerto_origen,
            },
            show: true,
        },
        port_discharge_id: {
            value: {
                id: booking.id_pod,
                name: booking.pod,
            },
            show: true,
        },
        port_destination_id: {
            value: {
                id: booking.id_destino_final,
                name: booking.destino_final,
            },
            show: true,
        },
        vessel: {
            value: booking.nave,
            show: true,
        },
        voyage: {
            value: booking.viaje,
            show: true,
        },
        haulage_carrier_id: {
            value: booking.transportista,
            show: true,
        },
        haulage_rampla_type: {
            value: booking.tipo_movimiento,
            show: true,
        },
        haulage_cost: {
            value: booking.costo_camionaje,
            show: true,
        },
        haulage_transport_type: {
            value: booking.tipo_transporte,
            show: true,
        },
        //Servicio Integral
        has_si: {
            value: booking.has_si == "1" ? "Si" : "No",
            show: true,
        },
        si_type_id: {
            value: {
                id: booking.si_type_id,
                name: booking.servicio_integral,
            },
            show: true,
        },
        //Shipper
        shipper: {
            value: {
                id: +booking.id_shipper,
                name: booking.shipper
            },
            show: true,
        },
        shipper_address_id: {
            value: {
                id: booking.shipper_address_id,
                name: booking.client_addresses_address,
            },
            show: true,
        },
        shipper_consignee_id: {
            value: {
                id: booking.id_consignatario,
                name: booking.consignatario,
            },
            show: true,
        },
        shipper_notify_id: {
            value: {
                id: booking.id_notify,
                name: booking.notify,
            },
            show: true,
        },
        //Información relevante a la carga
        type_container: {
            value: booking.tipo_contenedor,
            show: true,
        },
        container_id: {
            value: {
                id: booking.id_equipo,
                name: booking.equipo,
            },
            show: true,
        },
        id_client_product: {
            value: {
                id: booking.id_producto,
                name: booking.producto,
                id_product_type: booking.id_product_type
            },
            show: true,
        },
        embarked_containers: {
            value: "",
            show: false,
        },
        containers_requested: {
            value: booking.containers_requested,
            show: true,
        },
        cantidad_bi: {
            value: {
                name: 0,
            },
            show: false,
        },
        //IsReefer
        container_temperature: {
            value: booking.temperatura,
            show: true,
        },
        container_percent_ventilation: {
            value: booking.ventilacion,
            show: true,
        },
        container_cbm_ventilation: {
            value: booking.ventilacion_cbm,
            show: true,
        },
        container_cold_treatment: {
            value: booking.cold_treatment,
            show: true,
        },
        //isAtmosphera
        container_atmosphere_id: {
            value: {
                id: booking.container_atmosphere_id,
                name: booking.atmosfera,
            },
            show: true,
        },
        container_percent_o2: {
            value: booking.ventilacion_o2,
            show: true,
        },
        container_percent_co2: {
            value: booking.ventilacion_co2,
            show: true,
        },
        //Información adicional
        payment_method: {
            value: {
                id: booking.forma_pago_flete,
                name: booking.payment_method_name,
            },
            show: true,
        },
        genset: {
            value: booking.genset,
            show: true,
        },
        emition_bl: {
            value: booking.emision_bl,
            show: true,
        },
        comment: {
            value: booking.comentarios,
            show: true,
        },
        contract: {
            value: {
                id: booking.id_contrato,
                name: booking.contrato,
            },
            show: true,
        },
        contrato_booking: {
            value: booking.contrato_booking,
            show: true,
        },
        contract_number: {
            value: booking.contract_number,
            show: true,
        },

        itineraries: {
            naviera_id: booking.naviera_id,
        },
        with_frozen: {
            value: booking.with_frozen ? true : false,
        },
        with_ac: {
            value: booking.with_ac ? true : false,
        },
        //nuevos campo terrestre
        haulage_port_origin_id: {
            value: {
                id: booking.lugar_carga,
                name: booking.haulage_port_origin_name,
            },
        },
        haulage_withdrawal_date: {
            value: booking.fecha_retiro_unidad,
        },
        haulage_rampla: {
            value: booking.tipo_chasis,
        },
        haulage_packing_id: {
            value: {
                id: booking.packing,
                name: booking.haulage_packing_name,
            },
        },
        haulage_carrier: {
            value: booking.haulage_carrier_name,
        },
        haulage_movement_type: {
            value: booking.haulage_movement_type,
            show: true,
        },

        pol_etd: {
            value: booking.pol_etd,
            show: true,
        },
        shipper_id: {
            value: {
                id: booking.shipper_id,
                name: booking.shipper_name,
            },
            show: true,
        },
    }
    return bookingSerialized;
}